import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

const Template = ({ title, data, isImage }) => (
  <div className="col-12 my-1">
    {isImage ? (  
      <div className="cit-inner d-flex flex-column">
        <label
          className="font-weight-bold mb-0 mr-2"
          style={{ color: '#65676b' }}
        >
          {title} : 
        </label>
        <div className="narative-description p-2 my-2">
          {/* TODO: add image placeholder later */}
          { data ? <img className="img img-responsive" src={data} alt={title} /> : 'N/A' }
        </div>
      </div>
    ) : (
      <div className="cit-inner">
        <label className="font-weight-bold mb-0 mr-2 cit-label">
          {title}
        </label>
        <span className="cit-span">:</span>
        <span className="transaction-text p-0">{data}</span>
      </div>
    )}
  </div>
);

const TemplateTextArea = ({ title, data }) => (
  <div className="col-12 mt-2">
    <div className="cit-inner d-flex flex-column">
      <label
        className="font-weight-bold mb-0 mr-2"
        style={{ color: '#65676b' }}
      >
        {title} :
      </label>
      <div
        className="narative-description px-2 py-4 my-2"
        style={{
          height: '100%',
          width: '100%',
          border: '1px solid #9FA2A7',
          borderRadius: '5px',
        }}
      >
        {data}
        {/* {_.get(transactionInfo, 'attributes.valid_id_to_present') || '--'} */}
      </div>
    </div>
  </div>
);

const ProfileInformation = ({ seniorCitizenInfo }) => {
  return (
    <>
      <div className="row d-flex  mb-1 p-3">
        <Template title="Barangay Zone" data={_.get(seniorCitizenInfo, 'attributes.incident_type') || '- -'} />
        <hr />
        <Template title="Last Name" data={_.get(seniorCitizenInfo, 'attributes.last_name') || '- -'} />
        <Template title="First Name" data={_.get(seniorCitizenInfo, 'attributes.first_name') || '- -'} />
        <Template title="Middle Name" data={(_.get(seniorCitizenInfo, 'attributes.middle_name'))  || '- -'} />
        <Template title="Birth Date" data={(_.get(seniorCitizenInfo, 'attributes.birth_date'))  || '- -'} />
        <Template title="Address" data={(_.get(seniorCitizenInfo, 'attributes.address')) || '- -'} />
        <Template title="Contact No" data={_.get(seniorCitizenInfo, 'attributes.contact_number') || '- -'} />
        <Template title="Civil Status" data={_.get(seniorCitizenInfo, 'attributes.civil_status') || '- -'} />
        <Template title="Gender" data={_.get(seniorCitizenInfo, 'attributes.gender') || '- -'} />
        <Template title="Status" data={_.get(seniorCitizenInfo, 'attributes.status') || '- -'} />
        <Template title="Remarks" data={_.get(seniorCitizenInfo, 'attributes.remarks') || '- -'} />
      </div>
    </>
  );
};

Template.propTypes = {
  data: PropTypes.node, // any props
  title: PropTypes.string,
  isImage: PropTypes.bool,
}

Template.defaultProps = {
  title: '',
  data: '',
  isImage: false,
};

TemplateTextArea.propTypes = {
  data: PropTypes.node, // any props
  title: PropTypes.string,
};

TemplateTextArea.defaultProps = {
  title: '',
  data: '',
};

ProfileInformation.propTypes = {
  seniorCitizenInfo: PropTypes.instanceOf(Object).isRequired,
};

export default ProfileInformation;
